/**
 * Обработчик формы смены пароля
 */
import { disableButton, enableButton } from '@commonJs/utils';

$(document).on('submit', '.forgot-form, .find-city-form', function (e) {
    e.preventDefault();

    const targetForm = $(this);
    const button = targetForm.find('button');
    const successMessageBlock = targetForm.parents('.modal-body').find('.form-message');

    $.ajax({
        type: 'POST',
        url: targetForm.attr('action'),
        data: targetForm.serialize(),
        beforeSend: function () {
            disableButton(button);
        },
        success: function (data) {
            showErrors(targetForm, {});
            successMessageBlock.removeClass('d-none').html(data.text);
            targetForm.find('#inputEmailForgot').val('');
        },
        error: function (errors) {
            successMessageBlock.addClass('d-none').html();
            showErrors(targetForm, JSON.parse(errors.responseText));
        },
        complete: function () {
            enableButton(button);
        },
    });
});
